import {AbstractPreparedTransaction} from "../prepared_transaction";

export class DropletPreparedTransaction extends AbstractPreparedTransaction {}
